import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PostYourReqiurementService {
    
  constructor(private _http: HttpClient) { }

    searchcategory(data) {
        return this._http.post(environment.api_url+'searchcategory',data);
    }

    saverequirement(data) {
        return this._http.post(environment.api_url+'seller/product/requirement',data);
    }

}
